import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Box,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import DeleteIcon from "@mui/icons-material/Delete";

const EditInviteeDialog = ({
  open,
  onClose,
  editInvitee,
  setEditInvitee,
  onEdit,
  openAlert,
  setOpenAlert,
  errorMessage,
  arrangements,
  loading,
  handleDeleteInvitee,
}) => {
  const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleClose = () => {
    setOpenAlert(false); // アラートを閉じる
    onClose(); // モーダルを閉じる
  };

  const onDeleteInvitee = async () => {
    handleDeleteInvitee(editInvitee.id);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <Stack direction="row" justifyContent="space-between">
        <DialogTitle>招待者を編集</DialogTitle>
        {isSmallScreen ? (
          <IconButton style={{ margin: "0 12px 0 0" }}>
            <DeleteIcon onClick={() => setConfirmDeleteDialogOpen(true)} />
          </IconButton>
        ) : (
          <Button
            style={{ margin: "0 12px 0 0" }}
            onClick={() => setConfirmDeleteDialogOpen(true)}
          >
            この招待者を削除
          </Button>
        )}
        {/* <Button style={{ margin: '0 12px 0 0' }} onClick={() => setConfirmDeleteDialogOpen(true)}>この招待者を削除</Button> */}
      </Stack>
      <DialogContent>
        {/* <Box sx={{ width: '100%' }}>
                    <Collapse in={openAlert}>
                        <Alert
                            severity="error"
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setOpenAlert(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2 }}
                        >
                            {errorMessage}
                        </Alert>
                    </Collapse>
                </Box> */}

        <TextField
          margin="dense"
          label="呼び名"
          fullWidth
          value={editInvitee.nick_name || ""}
          onChange={(e) =>
            setEditInvitee({ ...editInvitee, nick_name: e.target.value })
          }
        />

        <FormControl fullWidth margin="dense">
          <InputLabel>テーブル</InputLabel>
          <Select
            value={editInvitee.arrangement_id || ""}
            onChange={(e) =>
              setEditInvitee({ ...editInvitee, arrangement_id: e.target.value })
            }
            label="テーブル"
          >
            {arrangements.map((arrangement) => (
              <MenuItem key={arrangement.id} value={arrangement.id}>
                {arrangement.arrangement_name}
              </MenuItem>
            ))}
            <MenuItem value="">テーブルを割り当てない</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="dense">
          <InputLabel>性別</InputLabel>
          <Select
            value={editInvitee.gender || ""}
            onChange={(e) =>
              setEditInvitee({ ...editInvitee, gender: e.target.value })
            }
            label="性別"
          >
            <MenuItem value="M">男</MenuItem>
            <MenuItem value="F">女</MenuItem>
          </Select>
        </FormControl>
        <TextField
          margin="dense"
          label="苗字"
          fullWidth
          value={editInvitee.last_name || ""}
          onChange={(e) =>
            setEditInvitee({ ...editInvitee, last_name: e.target.value })
          }
        />
        <TextField
          margin="dense"
          label="名前"
          fullWidth
          value={editInvitee.first_name || ""}
          onChange={(e) =>
            setEditInvitee({ ...editInvitee, first_name: e.target.value })
          }
        />
        <TextField
          margin="dense"
          label="アレルギー"
          fullWidth
          value={editInvitee.allergy || ""}
          onChange={(e) =>
            setEditInvitee({ ...editInvitee, allergy: e.target.value })
          }
        />

        <FormControl fullWidth margin="dense">
          <InputLabel>交通費</InputLabel>
          <Select
            value={
              editInvitee.travel_cost !== undefined
                ? editInvitee.travel_cost
                : ""
            }
            onChange={(e) =>
              setEditInvitee({ ...editInvitee, travel_cost: e.target.value })
            }
            label="送金状況"
          >
            <MenuItem value="yes">負担する</MenuItem>
            <MenuItem value="no">負担しない</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="dense">
          <InputLabel>送金状況</InputLabel>
          <Select
            value={editInvitee.is_paid !== undefined ? editInvitee.is_paid : ""}
            onChange={(e) =>
              setEditInvitee({
                ...editInvitee,
                is_paid: Number(e.target.value),
              })
            }
            label="送金状況"
          >
            <MenuItem value={0}>未送金</MenuItem>
            <MenuItem value={1}>送金済み</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="dense">
          <InputLabel>参加状況</InputLabel>
          <Select
            value={editInvitee.will || ""}
            onChange={(e) =>
              setEditInvitee({ ...editInvitee, will: e.target.value })
            }
            label="参加状況"
          >
            <MenuItem value="yes">参加</MenuItem>
            <MenuItem value="no">不参加</MenuItem>
            <MenuItem value="yet">未確定</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" sx={{ mr: 2, mb: 2 }} spacing={1}>
          <Button variant="contained" onClick={handleClose} color="secondary">
            キャンセル
          </Button>

          <Box sx={{ position: "relative" }}>
            <Button
              variant="contained"
              onClick={onEdit}
              disabled={loading}
              color="primary"
            >
              編集
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Box>
        </Stack>
      </DialogActions>

      {/* 削除確認ダイアログ */}
      <Dialog
        open={confirmDeleteDialogOpen}
        onClose={() => setConfirmDeleteDialogOpen(false)}
      >
        <DialogTitle>削除確認</DialogTitle>
        <DialogContent>
          <Typography variant="body1">この招待者を削除しますか？</Typography>
        </DialogContent>
        <DialogActions>
          <Stack direction="row" sx={{ mr: 2, mb: 2 }} spacing={1}>
            <Button
              variant="contained"
              onClick={() => setConfirmDeleteDialogOpen(false)}
              color="secondary"
            >
              キャンセル
            </Button>
            <Box sx={{ position: "relative" }}>
              <Button
                variant="contained"
                onClick={onDeleteInvitee}
                disabled={loading}
                color="primary"
              >
                削除
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    marginTop: "-12px",
                    marginLeft: "-12px",
                  }}
                />
              )}
            </Box>
          </Stack>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

export default EditInviteeDialog;
